{
  "qr-checkin-success-page": {
    "buttons": {
      "book-now": "JETZT BUCHEN",
      "find-salon": "SALON SUCHEN",
      "salon-page": "SALON-BUCHUNGSSEITE"
    },
    "text": {
      "checked-in": "Erfolgreich eingecheckt!",
      "checked-in-hint": "Sie können jederzeit einen neuen Termin für die nächste Behandlung buchen"
    },
    "meta": {
      "title": "QR-Check-in",
      "description": "Einchecken per QR-Code"
    }
  }
}
